function r(o = "h2", i, u = {}, c) {
  const n = (e) => typeof e == "string" && e.trim() !== "", h = ["title", "subTitle"], l = ["h1", "h2", "h3", "h4", "h5", "h6"];
  if (!h.includes(i) || o === "p")
    return "p";
  l.includes(o == null ? void 0 : o.toLowerCase()) || (o = "h2");
  //! ter de alinhar com o que o alexandre tem
  let f = parseInt(o.slice(1), 10);
  c && h.forEach((e) => {
    n(c[e]) && f++;
  });
  for (const e of h)
    if (n(u[e])) {
      if (f > 6)
        return "p";
      if (e === i)
        return `h${f}`;
      f++;
    }
  return "p";
}
export {
  r as getHeadingLevel
};
